import { SearchCriteria, SearchResults, AllCategorizedSearchResults } from 'common/types'
import { get } from 'hooks/use-http/useHttp'

const fetchUsersFromSearchCriteria = async (
  userId: string,
  page: number,
  searchCriteria: SearchCriteria,
  advancedSearch?: boolean
) => {
  const response: SearchResults = await get(
    `search/${userId}/users/?page=${page}&pageSize=10&dir=asc&sort=first_name&name=${searchCriteria.name ?? ''}&city=${
      searchCriteria.city ?? ''
    }&company=${searchCriteria.company ?? ''}&country=${searchCriteria.country ?? ''}&industry=${
      searchCriteria.industry ?? ''
    }&expertise=${searchCriteria.areaOfExpertise ?? ''}&age=${searchCriteria.ageRange ?? ''}&blackIdentified=${
      searchCriteria.blackIdentified ?? ''
    }&experienceLevel=${searchCriteria.experienceLevel ?? ''}&yearsOfExperience=${
      searchCriteria.yearsOfExperience ?? ''
    }&provinceState=${searchCriteria.province ?? ''}&gender=${
      searchCriteria.gender ?? ''
    }&advancedSearch=${advancedSearch}`
  )
  return response
}

export const fetchPartnersFromSearchCriteria = async (
  userId: string,
  page: number,
  searchCriteria: SearchCriteria,
  partnerType: string,
  advancedSearch?: boolean
) => {
  const response: SearchResults = await get(
    `search/${userId}/partners/?page=${page}&pageSize=10&dir=asc&sort=partner_name&type=${partnerType}&partnerName=${
      searchCriteria.company ?? ''
    }&city=${searchCriteria.city ?? ''}&country=${searchCriteria.country ?? ''}&industry=${
      searchCriteria.industry ?? ''
    }&expertise=${searchCriteria.areaOfExpertise ?? ''}&provinceState=${
      searchCriteria.province ?? ''
    }&advancedSearch=${advancedSearch}`
  )
  return response
}
export const fetchAllResultsByName = async (userId: string, searchQuery: string, page = 1) => {
  const response: SearchResults = await get(
    `search/${userId}/all/?page=${page}&pageSize=3&dir=asc&sort=first_name&name=${searchQuery}`,
    {
      useApiKey: true,
      dieSilent: true
    }
  )
  return response
}

export const fetchAllCategorizedSearchResultsByName = async (userId: string, searchQuery: string) => {
  const response: AllCategorizedSearchResults = await get(`search/${userId}/categories?name=${searchQuery}`, {
    useApiKey: true,
    dieSilent: true
  })
  return response
}

export const fetchChannelsFromSearchCriteria = async (userId: string, page: number, searchCriteria: SearchCriteria) => {
  const response: SearchResults = await get(
    `search/${userId}/channels?page=${page}&pageSize=10&dir=asc&sort=channel_name&name=${searchCriteria.name ?? ''}`
  )
  return response
}

export const useSearchApi = () => {
  return {
    fetchUsersFromSearchCriteria,
    fetchPartnersFromSearchCriteria,
    fetchAllResultsByName,
    fetchAllCategorizedSearchResultsByName,
    fetchChannelsFromSearchCriteria
  } as const
}
